import * as React from 'react';
import './main.scss';
import {
  BrowserRouter as Router,
  Route,
  Switch,
  RouteComponentProps,
} from 'react-router-dom';
import { ErrorView } from '@src/app/main/ErrorView';
import Home from '@src/app/home/Home';
//  import AccountsView from '@src/app/accounts/AccountsView';
import { Login } from '@src/app/login/components/Login';
import { actionCreators } from '@src/app/main/actions';
import { connect } from 'react-redux';
import { RootState } from '@src/app/_redux';
import { ConfigState, AdminConfigState } from '@src/app/main/reducers';
import {
  userIsAuthenticatedRedir,
  userIsNotAuthenticatedRedir,
} from '@src/app/_global/auth';
import '../_styles/index.scss';
import Notifications from 'react-notification-system-redux';
import Header from '@src/app/header/Header';
import Footer from '@src/app/footer/Footer';
import NatGeoFooter from '@src/app/footer/NatGeoFooter';
import { LoadingView } from '@src/app/_global/components/Loading';
import LoginCustomerService from '@src/app/accounts/customer-service/components/LoginCustomerService';
import { getAdminConfigTableItem } from '@src/app/_global/utility/adminConfigUtils';
import { InvalidRoute } from '@src/app/main/InvalidRoute';
import * as Loadable from 'react-loadable';
import { Helmet } from 'react-helmet';
import ReactGA from 'react-ga4';

const LoadCmp = ({ isLoading, error }) => {
  if (isLoading) {
    return <div>Loading...</div>;
  } else {
    return null;
  }
};

const AccountsView = Loadable({
  loader: () => import('@src/app/accounts/AccountsView'),
  loading: LoadCmp,
});
import {
  CognitoSuccessComponent,
  CognitoLogoutComponent,
  MyloLogoutComponent,
} from '@src/app/login/components/Cognito';
import { MyloSuccess } from '@src/app/login/components/Mylo';
import { MyloContinue } from '@src/app/login/components/MyloContinue';
import { DirectView } from '../login/components/DirectView';
import { CoreSSOSuccess } from '../login/components/CoreSSO';

const LoginComponent = userIsNotAuthenticatedRedir(Login);
const Protected = userIsAuthenticatedRedir(AccountsView);
const HomeComponent = userIsAuthenticatedRedir(Home);
const LoginCustomerServiceComponent = userIsNotAuthenticatedRedir(LoginCustomerService);

interface Props extends RouteComponentProps<{}> {
  getClientConfig: () => void;
  clientConfig: ConfigState;
  adminConfig: AdminConfigState;
  notifications: any;
}
const getDomainWithoutSubdomain = url => {
  const urlParts = new URL(url).hostname.split('.');

  let domain = urlParts
    .slice(0)
    .slice(-(2))
    .join('.');
  return domain;
};
class MainForm extends React.Component<Props> {
  constructor(props: any) {
    super(props);
    // throw new Error('sdf');
  }

  componentWillMount() {
    const { clientConfig } = this.props;
    if (clientConfig && !clientConfig.configLoaded) {
      this.props.getClientConfig();
    }
  }

  renderConfigLoadedView() {
    const { clientConfig, adminConfig, notifications } = this.props;
    let integrations = getAdminConfigTableItem(
      adminConfig,
      clientConfig,
      'ThirdPartyIntegrations',
    );
    let primaryGA4AnalyticsId =
         integrations.Preferences && integrations.Preferences.GoogleAnalytics4Id
          ? integrations.Preferences.GoogleAnalytics4Id
          : '';
    let secondaryGA4AnalyticsId =
        integrations.Preferences && integrations.Preferences.SecondaryGoogleAnalytics4Id
          ? integrations.Preferences.SecondaryGoogleAnalytics4Id
          : '';
    let domain = getDomainWithoutSubdomain(window.location.href );
    ReactGA.initialize([
      {
        trackingId: primaryGA4AnalyticsId  ,
        gaOptions: { name: 'CDS_SSP_GA4_Primary', cookieDomain: domain, send_page_view: true},
      }, 
      {
        trackingId: secondaryGA4AnalyticsId,
        gaOptions: { name: 'CDS_SSP_GA4_Secondary', cookieDomain: domain, send_page_view: true},
      }], 
      { testMode: false }
    );
    let signInData = getAdminConfigTableItem(this.props.adminConfig, this.props.clientConfig, 'SignIn');
    let title = signInData.PageTitle;
    let pageDescription = signInData.PageMetaDescription;
    let favicon = signInData.Favicon;
    let footerData = getAdminConfigTableItem(this.props.adminConfig, this.props.clientConfig, 'PageFooter');
    return (
      
      <div className="main-content">
        <Helmet>
            <meta name="description" content={pageDescription} />
            <title>{title}</title>
            <link href={favicon} rel="shortcut icon" />  
            { footerData.NatGeoCustomFooter && footerData.NatGeoCustomFooter.UseNatGeoCustomFooter && (
                window.location.href.includes('nationalgeographic') ? 
                <script src="/natgeo/datalayer-prod.js" type="text/javascript"></script>
                : 
                <script src="/natgeo/datalayer-test.js" type="text/javascript"></script>
            )}
            <script async={true} src={clientConfig.clientConfig.paymentCaptureUrl} type="text/javascript"/>
            { clientConfig.clientConfig.pingdomUrl && (
              <script src={clientConfig.clientConfig.pingdomUrl} async={true}></script>
            )}
            { footerData.NatGeoCustomFooter &&
              footerData.NatGeoCustomFooter.UseNatGeoCustomFooter && 
              footerData.NatGeoCustomFooter.NatGeoBootstrapUrl && (
              <script src={footerData.NatGeoCustomFooter.NatGeoBootstrapUrl} type="text/javascript"/>
            )}
          </Helmet>
        <Router>
          <>
            <a href="#main" className="top-skip-to-main">
              Skip to main content
            </a>
            <Header />
            <div className="main-body">
              <Switch>
                <Route exact={true} path="/" component={HomeComponent} />
                <Route path="/login" component={LoginComponent} />

                <Route path="/accounts" component={Protected} />
                <Route
                  path="/auth/success"
                  component={CognitoSuccessComponent}
                />
                <Route
                  path="/auth/core-sso"
                  component={CoreSSOSuccess}
                />
                <Route
                  path="/auth/core-sso-signup"
                  component={CoreSSOSuccess}
                />
                <Route
                  path="/auth/login"
                  component={MyloSuccess}
                />
                <Route
                  path="/mylo/continue"
                  component={MyloContinue}
                />
                <Route
                  path="/auth/logout"
                  component={MyloLogoutComponent}
                />
                <Route path="/logout" component={CognitoLogoutComponent} />
                <Route path="/loginCS" component={LoginCustomerServiceComponent} />
                <Route path="/directview/:path/:accountNumber/:postalCode/:orderNumber?" component={DirectView} />
                
                <Route component={InvalidRoute} />
              </Switch>
              <Notifications notifications={notifications} />
            </div>
            {this.renderFooter(footerData)}
            </>
        </Router>
      </div>
    );
  }

  renderErrorView(errorMessage: any) {
    return <ErrorView errorMessage={errorMessage} />;
  }

  renderLoadingView() {
    return <LoadingView loadingText="Loading..." />;
  }

  renderFooter(footerData: any) {
    if (footerData && 
        footerData.NatGeoCustomFooter && 
        footerData.NatGeoCustomFooter.UseNatGeoCustomFooter) {
      return <NatGeoFooter />;
    }
    return  <Footer />;
  }

  render() {
    const {
      configFailure,
      errorMessage,
      configLoaded,
    } = this.props.clientConfig;
    let viewToShow;
    if (configLoaded) {
      viewToShow = this.renderConfigLoadedView();
    } else if (configFailure) {
      viewToShow = this.renderErrorView(errorMessage);
    } else {
      viewToShow = this.renderLoadingView();
    }
    return viewToShow;
  }
}

const mapStateToProps = (state: RootState) => ({
  clientConfig: state.clientConfig,
  adminConfig: state.adminConfig,
  notifications: state.notifications,
});

export const Main = connect(
  mapStateToProps,
  {
    getClientConfig: actionCreators.getClientConfig,
  },
)(MainForm);
